<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { AIR, CRUISE } from '@/constants';
import { useAdminSetupStore } from '@/store/AdminSetupStore';
import { useToast } from 'primevue/usetoast';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import EmailConfigOneWayOpenJaw from '@/components/configuration/EmailConfigOneWayOpenJaw.vue';

const isLoading = ref(false);
const { t } = useI18n({ useScope: 'global' });
const toast = useToast();
const adminSetupStore = useAdminSetupStore();
const listEmailOneWayOpenJawAir = ref();
const listEmailOneWayOpenJawCruise = ref();

const getListOneWayOpenJawAir = () => {
  isLoading.value = true;
  adminSetupStore
    .getOneWayOpenJawConfig(AIR)
    .then((res) => {
      listEmailOneWayOpenJawAir.value = res.data;
    })
    .finally(() => (isLoading.value = false));
};

const getListOneWayOpenJawCruise = () => {
  isLoading.value = true;
  adminSetupStore
    .getOneWayOpenJawConfig(CRUISE)
    .then((res) => {
      listEmailOneWayOpenJawCruise.value = res.data;
    })
    .finally(() => (isLoading.value = false));
};

const handleUpdateConfig = (event: any) => {
  const payload = {
    jawType: event?.jawType,
    data: event?.data
  };
  adminSetupStore
    .updateOneWayOpenJawConfig(payload)
    .then(() => {
      toast.add({ severity: 'success', summary: '', detail: t('notification.save_successfully'), life: 3000 });
    })
    .catch(() => {
      toast.add({ severity: 'error', summary: '', detail: t('notification.save_error'), life: 5000 });
    });
};

onMounted(async () => {
  getListOneWayOpenJawAir();
  getListOneWayOpenJawCruise();
});
</script>
<template>
  <div class="oneWay-openJaw-config">
    <LoadingSpinner v-if="isLoading" />
    <div v-else class="card">
      <h4>{{ $t('management.email.one_way_open_jaw_exclusion') }}</h4>
      <div class="flex flex-wrap justify-content-between mt-5">
        <div class="open-jaw">
          <h5 class="title">{{ $t('management.email.one_way_open_jaw_exclusion') }}</h5>
          <EmailConfigOneWayOpenJaw class="cruise" v-model:brochureCode="listEmailOneWayOpenJawCruise" :title="$t('common.cruise')" :jawType="CRUISE" @handleUpdateConfig="handleUpdateConfig($event)"></EmailConfigOneWayOpenJaw>
          <EmailConfigOneWayOpenJaw class="air" v-model:brochureCode="listEmailOneWayOpenJawAir" :title="$t('common.air')" :jawType="AIR" @handleUpdateConfig="handleUpdateConfig($event)"></EmailConfigOneWayOpenJaw>
        </div>
      </div>
    </div>
  </div>
</template>
